import { Font } from '@react-pdf/renderer';

// Local copies — avoids 4× CDN round-trips on every PDF generation.
// Vite resolves these as static asset URLs at build time.
import publicSans300 from '@/assets/fonts/PublicSans-300.ttf?url';
import publicSans400 from '@/assets/fonts/PublicSans-400.ttf?url';
import publicSans600 from '@/assets/fonts/PublicSans-600.ttf?url';
import publicSans700 from '@/assets/fonts/PublicSans-700.ttf?url';

let registered = false;

/**
 * Registers Public Sans with react-pdf's font engine.
 *
 * Safe to call multiple times — registration only happens once.
 * Must be called before any PDF document is rendered.
 */
export function registerPdfFonts(): void {
  if (registered) return;

  Font.register({
    family: 'Public Sans',
    fonts: [
      { src: publicSans300, fontWeight: 300 },
      { src: publicSans400, fontWeight: 400 },
      { src: publicSans600, fontWeight: 600 },
      { src: publicSans700, fontWeight: 700 },
    ],
  });

  // Disable hyphenation — react-pdf hyphenates long words by default
  Font.registerHyphenationCallback((word) => [word]);

  registered = true;
}
